module.exports = __webpack_public_path__ + "static/media/refresh.d3e8dab9.png";